// Çelësat që duhen ruajtur kur pastrohet localStorage gjatë logout / 401.
// "nexuma_seen_v*" mban gjurmën nëse përdoruesi e ka parë modalin e
// "Përditësimet e Sistemit" për versionin aktual; pa këtë, modali do
// të shfaqej përsëri pas çdo logout-i.
export const PERSISTENT_LOCAL_STORAGE_PREFIXES = ['nexuma_seen_v'];

export const clearStoragePreservingSeen = () => {
  const preserved = {};
  try {
    Object.keys(localStorage)
      .filter((k) => PERSISTENT_LOCAL_STORAGE_PREFIXES.some((p) => k.startsWith(p)))
      .forEach((k) => { preserved[k] = localStorage.getItem(k); });
  } catch {}
  try { localStorage.clear(); } catch {}
  try {
    Object.entries(preserved).forEach(([k, v]) => {
      if (v != null) localStorage.setItem(k, v);
    });
  } catch {}
};
